export default __webpack_public_path__ + "static/media/foxhome-logo-w.3aaccfbe.svg";